export default __webpack_public_path__ + "28854ee1707e3ec69cd2654f329c9d7b.png";